import { Card, Button } from 'src/components/UIComponents';
import messages from './ListeLogs.json'
import moment from 'moment';

export default {
    name: "ListeLogs",
    i18n: messages,

    components: {
        Card,
        [Button.name]: Button
    },

    data() {
        return {
            data: [],
            search: '',
            dates: []
        }
    },

    mounted() {
        this.updateData()
    },

    methods: {
        /**
         * Récupération des données
         */
        updateData() {
            this.$eventHub.$emit(this.$eventHub.LOADING.START)

            this.$axios.get('rest/bd/logs/',
            {
                params: {
                    dateDebut: !this.$val.isEmpty(this.dates) ? this.dates[0] : null,
                    dateFin: !this.$val.isEmpty(this.dates) ? this.dates[1] : null
                }
              }).then(
              response => {
                this.updateDataSuccess(response.data)
                this.$eventHub.$emit(this.$eventHub.LOADING.END)
              },
              error => {
                this.updateDataFailed(error.response)
                this.$eventHub.$emit(this.$eventHub.LOADING.END)
              }
            )
          },

              /**
         * Données filtrées après recherche
         */
        filteredList() {
            return this.data.filter(logs => {
              return (moment(logs.date).format('DD/MM/YYYY') + logs.user.mail + logs.user.prenom + logs.user.nom + this.$t('typeLog.' + logs.typeLog)).toLowerCase().includes(this.search.toLowerCase())
            })
          },
                  /**
         * Appelé lorsque la récupération des données s'est bien passée
         */
        updateDataSuccess(data) {
            this.data = data ;
        },
        updateDataFailed(reponse) {
            //on notifie l'erreur a l'utilisateur
            this.$notify({
                title: this.$t('notifications.echecRecuperationDonnees.title'),
                message: this.$t('notifications.echecRecuperationDonnees.message'),
                horizontalAlign: 'right',
                verticalAlign: 'bottom',
                type: 'error',
                timeout: 5000,
                closeOnClick: true
            })
        },
        /**
         * Permet de get la structure de l'utilisateur
         * Prend la premiere structure trouvée parmis les postes en cours ou futur de l'utilisateur
         *
         * @param row
         * @returns {null|*|string}
         * @private
         */
        _getStructure(row) {
            const user = row.user

            if (!user.postesEnCours.length && !user.postesFutur.length) return

            let structure

            if (user.postesEnCours.length) {
              structure = user.postesEnCours[0].structure
            } else if (user.postesFutur.length) {
              structure = user.postesFutur[0].structure
            }

            return structure ? structure.nom : ''
        }
    }
}
